var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 100,
    viewBox: "0 0 89 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.7115 39.0386V71.6612C88.7026 72.8228 88.3903 73.9618 87.8056 74.9655C87.2209 75.9693 86.3841 76.8028 85.3782 77.3835L82.3448 79.1391L76.078 82.7725L63.4556 90.0726L57.1445 93.7171L50.8333 97.3616L47.8332 99.0949C46.8224 99.6878 45.6717 100 44.4998 100C43.328 100 42.1773 99.6878 41.1665 99.0949L38.1664 97.3616L31.8441 93.7171V86.4281L38.1553 90.0726L44.4665 93.7171L50.7777 90.0726L57.0889 86.4281V79.1391L50.8221 82.7725L44.5665 86.4281L38.1998 82.7725V75.4724L44.5109 79.128L50.8221 75.4724L57.1333 71.8279L63.4445 68.1834L69.7668 64.5389L76.078 60.8944V68.1834L69.7668 71.8279L63.4556 75.4835V82.7725L69.7668 79.128L76.078 75.4835L82.3892 71.8501V49.9721L76.078 53.6165L69.7668 57.2166L63.4556 60.9055L57.1445 64.55L44.5665 71.839L31.9441 64.55V57.2166L38.2664 60.8611L44.5665 64.55L50.8777 60.9055L57.1889 57.261L63.5001 53.6165L69.8224 49.9721L76.1336 46.3276L82.4448 42.6831L88.7115 39.0386Z",
    fill: "url(#paint0_linear_153_938)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5667 31.7485L19.2555 35.393V71.849L12.9443 68.1934V31.7485L19.2555 28.104L25.5667 31.7485Z",
    fill: "url(#paint1_linear_153_938)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.712 28.3269V39.0937L82.3453 42.6715V28.0935L76.0341 24.4491L69.7229 20.8046L63.4561 17.2156L57.1449 13.5711L50.8337 9.92664L44.567 6.22658L38.2558 9.87108L31.9446 13.5156L25.5667 17.2156L31.8779 20.8601L38.1891 24.5046L44.5003 28.1491L50.8115 31.7936L57.1227 35.4492L63.4339 39.0826V46.3827L69.7451 42.7382V35.4381L63.4561 31.738L57.1449 28.0935L50.8337 24.4491L44.567 20.8046L38.2002 17.2156L44.567 13.5156L50.8226 17.2156L57.1338 20.8601L63.4561 24.4491L69.7784 28.0935L76.0896 31.738V46.3271L69.7784 49.9716L63.4561 53.6161L57.1338 57.2162V42.6715L50.8226 39.0381L44.567 35.3825L38.2558 31.738L31.9335 28.0935L25.6223 24.4491L19.3111 20.8046L12.9443 17.2156L19.2555 13.5711L25.5667 9.92664L31.8779 6.28214L38.1891 2.63764L41.1892 0.893177C42.2026 0.308047 43.3523 0 44.5225 0C45.6928 0 46.8424 0.308047 47.8559 0.893177L50.856 2.63764L57.1671 6.28214L63.4561 9.87108L69.7784 13.5156L76.0785 17.2156L82.3453 20.8046L85.3453 22.5379C86.3672 23.1201 87.217 23.9623 87.8083 24.979C88.3996 25.9957 88.7113 27.1507 88.712 28.3269Z",
    fill: "url(#paint2_linear_153_938)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5665 35.3822L38.2553 39.0267L31.9441 42.6601V93.7052L25.6329 90.0608L12.9438 82.7718L6.6215 79.1273L3.62146 77.3828C2.61021 76.8081 1.76911 75.9759 1.18364 74.9709C0.598163 73.9658 0.289181 72.8237 0.288086 71.6605V28.3266C0.295108 27.1632 0.606478 26.0218 1.19126 25.016C1.77604 24.0102 2.61386 23.1749 3.62146 22.5932L6.6215 20.8598L12.9438 17.2153L19.255 20.8598L12.9438 24.5043L6.63261 28.1488V71.905L12.9549 75.5383L19.2661 79.1828L25.5662 82.7718V39.0267L31.8774 35.3934L38.1997 31.7377L44.5665 35.3822Z",
    fill: "url(#paint3_linear_153_938)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_153_938",
    x1: 83.3115,
    y1: 68.1612,
    x2: 29.0663,
    y2: 72.5724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_153_938",
    x1: 8.18872,
    y1: 82.5269,
    x2: 24.6445,
    y2: 18.5817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_153_938",
    x1: 39.5225,
    y1: 2.61542,
    x2: 68.334,
    y2: 51.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_153_938",
    x1: 10.2993,
    y1: 83.0718,
    x2: 26.7662,
    y2: 19.1265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02FFFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo_3.7c06e9fcf3c6d69e10ecfd0a8fbb08d8.svg";
export { ForwardRef as ReactComponent };